import _createForOfIteratorHelper from "/usr/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
var __jsx = React.createElement;
import React, { createContext, useContext, useEffect, useState } from 'react';

// Define the structure for currency replacements

// Context interface

// Create the context
var CurrencyFontContext = /*#__PURE__*/createContext(undefined);

// Props for the provider

var replacements = [{
  text: "SAR",
  symbol: "﷼"
}, {
  text: "R.S",
  symbol: "﷼"
}, {
  text: "R.s",
  symbol: "﷼"
}, {
  text: "ريال",
  symbol: "﷼"
}, {
  text: "ر.س",
  symbol: "﷼"
}, {
  text: "⃀",
  symbol: "﷼"
}];

/**
 * Helper function to check if a currency text is a standalone word
 * or part of another word
 */
var isStandaloneCurrency = function isStandaloneCurrency(fullText, currencyText, index) {
  // Check if the currency is at the start of the string
  var isAtStart = index === 0;

  // Check if the currency is at the end of the string
  var isAtEnd = index + currencyText.length === fullText.length;

  // Check what's before the currency (if not at start)
  var charBefore = !isAtStart ? fullText[index - 1] : null;

  // Check what's after the currency (if not at end)
  var charAfter = !isAtEnd ? fullText[index + currencyText.length] : null;

  // Currency is standalone if:
  // 1. It's the whole string, or
  // 2. It's at the start and followed by space/punctuation, or
  // 3. It's at the end and preceded by space/punctuation, or
  // 4. It's surrounded by space/punctuation

  var isWordBoundaryChar = function isWordBoundaryChar(_char) {
    if (_char === null) return true;
    return /[\s\.,;:!?()[\]{}\/\-\d]/.test(_char);
  };
  return isAtStart && isAtEnd || isAtStart && isWordBoundaryChar(charAfter) || isAtEnd && isWordBoundaryChar(charBefore) || isWordBoundaryChar(charBefore) && isWordBoundaryChar(charAfter);
};

/**
 * CurrencyFontProvider component that provides client-side enhancement
 */
export var CurrencyFontProvider = function CurrencyFontProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(true),
    enabled = _useState[0],
    setEnabled = _useState[1];
  useEffect(function () {
    if (!enabled) return;

    // Client-side processing for dynamic content
    var observer = new MutationObserver(function (mutations) {
      // Process only if we have childList mutations
      var hasRelevantMutations = mutations.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (!hasRelevantMutations) return;

      // Remove processed marker from elements whose children changed so they are re-processed
      mutations.forEach(function (m) {
        if (m.type === 'childList' && m.target instanceof HTMLElement) {
          m.target.removeAttribute('data-currency-processed');
        }
      });

      // Process in next animation frame for better performance
      requestAnimationFrame(function () {
        processDynamicContent();
      });
    });

    // Optimized currency text replacement
    var _replaceCurrencyText = function replaceCurrencyText(element) {
      // Skip if already processed
      if (element.hasAttribute('data-currency-processed')) return;

      // Skip certain elements
      if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE' || element.tagName === 'TITLE' || element.tagName === 'META' || element.tagName === 'LINK' || element.classList.contains('syarah-currency-icon') || element.classList.contains('no-currency-icon')) {
        return;
      }

      // Process child nodes
      Array.from(element.childNodes).forEach(function (child) {
        // Text node
        if (child.nodeType === Node.TEXT_NODE) {
          var nodeText = child.textContent || '';
          var foundReplacements = false;
          var replacementPositions = [];

          // Find all positions of replacements that are standalone (not part of other words)
          for (var _i = 0, _replacements = replacements; _i < _replacements.length; _i++) {
            var text = _replacements[_i].text;
            var index = nodeText.indexOf(text);
            while (index !== -1) {
              // Check if this occurrence is a standalone currency and not part of another word
              if (isStandaloneCurrency(nodeText, text, index)) {
                replacementPositions.push({
                  start: index,
                  end: index + text.length,
                  text: text
                });
                foundReplacements = true;
              }
              index = nodeText.indexOf(text, index + 1);
            }
          }
          if (foundReplacements) {
            // Sort positions by start index
            replacementPositions.sort(function (a, b) {
              return a.start - b.start;
            });

            // Filter out overlapping positions
            var finalPositions = [];
            var _iterator = _createForOfIteratorHelper(replacementPositions),
              _step;
            try {
              var _loop = function _loop() {
                var pos = _step.value;
                var overlaps = finalPositions.some(function (existing) {
                  return pos.start >= existing.start && pos.start < existing.end || pos.end > existing.start && pos.end <= existing.end;
                });
                if (!overlaps) {
                  finalPositions.push(pos);
                }
              };
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _loop();
              }

              // Check if parent is a span with exactly the currency text
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            var parent = child.parentElement;
            if (parent && parent.tagName === 'SPAN' && parent.childNodes.length === 1 && finalPositions.length === 1 && nodeText.trim() === finalPositions[0].text.trim()) {
              // Replace the span with an icon
              parent.classList.add('syarah-currency-icon');
              parent.setAttribute('data-currency-processed', 'true');
              parent.innerText = '';
            } else {
              var _child$parentNode;
              // Replace occurrences in text
              var fragment = document.createDocumentFragment();
              var lastIndex = 0;

              // Execute the replacements
              var _iterator2 = _createForOfIteratorHelper(finalPositions),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _step2$value = _step2.value,
                    start = _step2$value.start,
                    end = _step2$value.end;
                  // Add text before replacement
                  if (start > lastIndex) {
                    fragment.appendChild(document.createTextNode(nodeText.substring(lastIndex, start)));
                  }

                  // Add icon
                  var iconElement = document.createElement('span');
                  iconElement.className = 'syarah-currency-icon';
                  fragment.appendChild(iconElement);
                  lastIndex = end;
                }

                // Add remaining text
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (lastIndex < nodeText.length) {
                fragment.appendChild(document.createTextNode(nodeText.substring(lastIndex)));
              }

              // Replace the original node
              (_child$parentNode = child.parentNode) === null || _child$parentNode === void 0 ? void 0 : _child$parentNode.replaceChild(fragment, child);
            }
          }
        }
        // Element node - process recursively
        else if (child.nodeType === Node.ELEMENT_NODE) {
          _replaceCurrencyText(child);
        }
      });
      element.setAttribute('data-currency-processed', 'true');
    };

    // Process all visible content on the page
    var processDynamicContent = function processDynamicContent() {
      // Only process elements that might contain our target text
      var potentialElements = Array.from(document.querySelectorAll('*:not([data-currency-processed])'));

      // Filter to elements that contain target text
      var elementsToProcess = potentialElements.filter(function (el) {
        var text = el.textContent || '';
        // Check if any replacement text exists in the element
        return replacements.some(function (_ref2) {
          var replaceText = _ref2.text;
          return text.includes(replaceText);
        });
      });

      // Process in smaller batches
      var batchSize = 500;
      var _loop2 = function _loop2() {
        var batch = elementsToProcess.slice(i, i + batchSize);
        setTimeout(function () {
          batch.forEach(function (element) {
            _replaceCurrencyText(element);
          });
        }, 0);
      };
      for (var i = 0; i < elementsToProcess.length; i += batchSize) {
        _loop2();
      }
    };

    // Start observing changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Process initial content after a slight delay
    setTimeout(processDynamicContent, 10);

    // Cleanup on unmount
    return function () {
      observer.disconnect();
      // Clean up processed markers
      document.querySelectorAll('[data-currency-processed]').forEach(function (el) {
        el.removeAttribute('data-currency-processed');
      });
    };
  }, [enabled]);
  var toggleEnabled = function toggleEnabled() {
    setEnabled(function (prev) {
      return !prev;
    });
  };
  var contextValue = {
    replacements: replacements,
    enabled: enabled,
    toggleEnabled: toggleEnabled
  };
  return /*#__PURE__*/React.createElement(CurrencyFontContext.Provider, {
    value: contextValue
  }, children);
};

/**
 * Replaces occurrences of specified text with currency symbols
 * @param {string} text - The original text to process
 * @param {HTMLElement} container - The container element to add the processed content to
 */
export var replaceTextWithCurrencySymbols = function replaceTextWithCurrencySymbols(text, container) {
  // Skip if no text or replacements
  if (!text || typeof text !== "string" || !replacements || replacements.length === 0) return;

  // Find all standalone currency occurrences
  var replacementPositions = [];

  // Check for standalone currency occurrences
  for (var _i2 = 0, _replacements2 = replacements; _i2 < _replacements2.length; _i2++) {
    var replaceText = _replacements2[_i2].text;
    var index = text.indexOf(replaceText);
    while (index !== -1) {
      // Check if this occurrence is a standalone currency
      if (isStandaloneCurrency(text, replaceText, index)) {
        replacementPositions.push({
          start: index,
          end: index + replaceText.length,
          text: replaceText
        });
      }
      index = text.indexOf(replaceText, index + 1);
    }
  }
  if (replacementPositions.length === 0) {
    // No replacements needed, just set the text
    container.textContent = text;
    return;
  }

  // Sort positions by start index
  replacementPositions.sort(function (a, b) {
    return a.start - b.start;
  });

  // Filter out overlapping positions
  var finalPositions = [];
  var _loop3 = function _loop3() {
    var pos = _replacementPositions[_i3];
    var overlaps = finalPositions.some(function (existing) {
      return pos.start >= existing.start && pos.start < existing.end || pos.end > existing.start && pos.end <= existing.end;
    });
    if (!overlaps) {
      finalPositions.push(pos);
    }
  };
  for (var _i3 = 0, _replacementPositions = replacementPositions; _i3 < _replacementPositions.length; _i3++) {
    _loop3();
  }

  // Create a document fragment to build the replacement
  var fragment = document.createDocumentFragment();
  var lastIndex = 0;

  // Execute the replacements
  for (var _i4 = 0, _finalPositions = finalPositions; _i4 < _finalPositions.length; _i4++) {
    var _finalPositions$_i = _finalPositions[_i4],
      start = _finalPositions$_i.start,
      end = _finalPositions$_i.end,
      _replaceText = _finalPositions$_i.text;
    // Add text before replacement
    if (start > lastIndex) {
      fragment.appendChild(document.createTextNode(text.substring(lastIndex, start)));
    }

    // Add the symbol
    var symbolElement = document.createElement('span');
    symbolElement.className = 'syarah-currency-icon';
    fragment.appendChild(symbolElement);
    lastIndex = end;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
  }

  // Clear the container and add the new content
  while (container.firstChild) {
    container.removeChild(container.firstChild);
  }
  container.appendChild(fragment);
};

/**
 * Hook for accessing the currency font context
 */
export var useCurrencyFont = function useCurrencyFont() {
  var context = useContext(CurrencyFontContext);
  if (!context) {
    throw new Error('useCurrencyFont must be used within a CurrencyFontProvider');
  }
  return context;
};

/**
 * Simple component to render a currency icon
 */
export var CurrencyIcon = function CurrencyIcon() {
  return /*#__PURE__*/React.createElement("i", {
    className: "syarah-currency-icon",
    "aria-hidden": "true"
  });
};
export default CurrencyFontProvider;